// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:48:13

export default {
  "id": "royal-coin-rush",
  "slug": "royal-coin-rush",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/a261dc8c8db44399a9da4ee98a285907-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/a261dc8c8db44399a9da4ee98a285907/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "ROYAL COIN RUSH",
      "description": "Drag adjacent coins to swap them, and line up three or more vertically or horizontally to remove them. Special coins appear when 4 or more coins are matched. Mix effects by combining special items! The stage is cleared when all the target coins are erased.",
      "instructions": "Swipe to move coins",
      "genres": [
        "Match-3"
      ],
      "tags": [
        "casino",
        "collect",
        "combo",
        "match3",
        "treasure"
      ]
    },
    "zh-CN": {
      "title": "皇家币冲浪",
      "description": "将相邻的硬币拖动以交换它们，并使三个或更多硬币垂直或水平排列以移除它们。当匹配4个或更多硬币时会出现特殊硬币。通过组合特殊物品来混合效果！当所有目标硬币被清除时，关卡即被通关。",
      "instructions": "滑动以移动金币",
      "genres": [
        "三消匹配"
      ],
      "tags": [
        "赌场",
        "收集",
        "组合",
        "三消",
        "宝藏"
      ]
    },
    "zh-TW": {
      "title": "皇家錢幣衝擊",
      "description": "拖動相鄰的硬幣以交換它們，並將三個或以上的硬幣排成直線或水平線來移除它們。當匹配四個或以上的硬幣時會出現特殊硬幣。通過組合特殊物品來混合效果！當所有目標硬幣都被擦除時，階段將被清除。",
      "instructions": "滑動以移動硬幣",
      "genres": [
        "配對3"
      ],
      "tags": [
        "賭場",
        "收集",
        "組合",
        "三消匹配",
        "寶藏"
      ]
    },
    "zh-HK": {
      "title": "皇家錢幣衝擊",
      "description": "將相鄰的硬幣拖動以交換它們，並將三個或更多硬幣水平或垂直排列以移除它們。當匹配四個或更多硬幣時會出現特殊硬幣。通過組合特殊物品來混搭效果！當所有目標硬幣都被消除時，該關卡即被通過。",
      "instructions": "滑動以移動硬幣",
      "genres": [
        "配對3"
      ],
      "tags": [
        "賭場",
        "收集",
        "組合",
        "三消對齊",
        "寶藏"
      ]
    },
    "ja": {
      "title": "王冠コインレース",
      "description": "隣接するコインをドラッグして交換し、垂直または水平に3つ以上揃えて取り除きます。4つ以上の同じコインが揃ったときに特別なコインが現れます。特別アイテムを組み合わせて効果を混ぜ合わせてください！目標のコインがすべて消えたときにステージがクリアされます。",
      "instructions": "コインを動かすためにスワイプしてください",
      "genres": [
        "マッチ3"
      ],
      "tags": [
        "カジノ",
        "収集",
        "コンボ",
        "マッチ3",
        "宝物"
      ]
    },
    "ko": {
      "title": "로얄 코인 런치",
      "description": "접속한 동전을 드래그하여 교환하세요, 수직이나 수평으로 3개 이상의 동전을 일치시키면 제거합니다. 4개 이상의 동전이 일치하면 특수 동전이 출현합니다. 특수 아이템을 결합하여 효과를 혼합하세요! 모든 목표 동전이 지워지면 스테이지가 클리어됩니다.",
      "instructions": "화폐를 이동시키기 위해 스크롤하세요",
      "genres": [
        "매치3"
      ],
      "tags": [
        "카지노",
        "모으기",
        "조합",
        "매치3",
        "보물"
      ]
    },
    "fr": {
      "title": "Élan des Pièces Royales",
      "description": "Faites glisser les monnaies adjacentes pour les échanger, et alignez en trois ou plus verticalement ou horizontalement pour les supprimer. Des monnaies spéciales apparaissent lorsque 4 ou plus sont alignées. Mélangez les effets en combinant des objets spéciaux ! Le niveau est clearing lorsque toutes les monnaies cibles sont supprimées.",
      "instructions": "Faites glisser pour déplacer les pièces",
      "genres": [
        "Criss-Cross 3"
      ],
      "tags": [
        "casino",
        "collecter",
        "combinaison",
        "match3",
        "trésor"
      ]
    }
  }
};
